import { Checkbox, Link, Stack, Typography } from "@mui/material";
import React from "react";
import ShipmentStatusChip from "../components/ShipmentStatusChip";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const GroupageShipmentRow = (props) => {
  const { shipment, isChecked, handleChecked, enableClosedShipment } = props;
  const latestStatus =
    shipment &&
    shipment.ShipmentStatuses &&
    shipment.ShipmentStatuses.length > 0
      ? shipment.ShipmentStatuses[shipment.ShipmentStatuses.length - 1]
      : null;

  return (
    <div>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" gap={1}>
          {(!shipment.isClosed || enableClosedShipment) && (
            <Checkbox
              sx={{ p: 0 }}
              checked={isChecked}
              onChange={(e) => handleChecked(shipment)}
            />
          )}
          <Typography
            variant="body2"
            className="display-linebreak"
            sx={{ mt: 0.3, mr: 1 }}
          >
            <Link
              color="inherit"
              underline="hover"
              target="blank"
              href={`/shipment/${shipment.id}`}
            >
              {shipment.shipmentNo}
            </Link>
          </Typography>
        </Stack>
        {latestStatus && (
          <ShipmentStatusChip
            status={latestStatus.status}
            variant="filled"
            color={latestStatus.type}
            size="medium"
          />
        )}
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <ArrowForwardIcon />
        <Typography variant="caption">
          {shipment?.to.split(/\r?\n/)[0]}
        </Typography>
      </Stack>
      <hr />
    </div>
  );
};

export default GroupageShipmentRow;
